import { render, staticRenderFns } from "./ManageAddress.vue?vue&type=template&id=17479f2c&lang=pug&"
import script from "./ManageAddress.vue?vue&type=script&lang=js&"
export * from "./ManageAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports